import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {AsyncPipe, NgIf} from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {Observable} from 'rxjs';
import {TranslateModule} from '@ngx-translate/core';
import {TreeModule} from 'ng-tree-component';
import {
  ContentLoaderComponent,
  DialogCloseButtonComponent,
  IconButtonComponent
} from '@q9elements/ui-kit/components';
import {ExternalGptConfig, Q9ElementsGptService} from '@q9elements/ui-kit/common';
import {DraggableDialogDirective} from '../../shared/directives/draggable-dialog.directive';
import {ResizableDialogDirective} from '../../shared/directives/resizable-dialog.directive';
import {ClipboardService} from '../../services/clipboard.service';
import {EditorInterfaceSharedModule} from '../../shared/editor-interface-shared.module';
import {TextToHtmlPipe} from '../../shared/pipes/text-to-html.pipe';

@Component({
  selector: 'app-agentforce-dialog',
  templateUrl: './agentforce-dialog.component.html',
  styleUrls: ['./agentforce-dialog.component.scss'],
  imports: [
    DraggableDialogDirective,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatProgressBarModule,
    ResizableDialogDirective,
    TranslateModule,
    TreeModule,
    EditorInterfaceSharedModule,
    DialogCloseButtonComponent,
    IconButtonComponent,
    TextToHtmlPipe,
    AsyncPipe,
    ContentLoaderComponent,
    NgIf
  ],
  standalone: true,
  encapsulation: ViewEncapsulation.None
})
export class AgentforceDialogComponent {
  public type = this.data.instructions ? 'INSTRUCTIONS' : 'TEST';
  public modalTitle = `ASIDE_R.AGENTFORCE_TITLE_${this.type}`;
  public externalGptConfig$: Observable<ExternalGptConfig> =
    this.generationPermissionService.getExternalGptConfig();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private clipboardService: ClipboardService,
    private generationPermissionService: Q9ElementsGptService
  ) {}

  protected copyLinkToClipboard(): void {
    const successMsg = `ASIDE_R.AGENTFORCE_${this.type}_COPIED`;
    const value = this.data.instructions || this.data.testUtterances;

    this.clipboardService.copyToClipboard(value, successMsg);
  }

  protected getTranslateParams(enabled: boolean): {provider: string} {
    return {
      provider: enabled ? '(Externalized service)' : '(Elements OpenAI integration)'
    };
  }
}
